export default "__VITE_ASSET__56109b54__"